import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const TONES = {
  info: {
    bg: "var(--wp-status-info-bg, #EEF5FF)",
    border: "var(--wp-status-info-border, #B9D5FF)",
    icon: "var(--wp-status-info-icon, #2463A8)",
    text: "var(--wp-status-info-text, #173B65)",
  },
  success: {
    bg: "var(--wp-status-success-bg, #ECF9F1)",
    border: "var(--wp-status-success-border, #A9DEC0)",
    icon: "var(--wp-status-success-icon, #1E7A46)",
    text: "var(--wp-status-success-text, #175A36)",
  },
  warning: {
    bg: "var(--wp-status-warning-bg, #FFF6E8)",
    border: "var(--wp-status-warning-border, #F4CF91)",
    icon: "var(--wp-status-warning-icon, #A86200)",
    text: "var(--wp-status-warning-text, #744600)",
  },
  danger: {
    bg: "var(--wp-status-danger-bg, #FFF0F0)",
    border: "var(--wp-status-danger-border, #F2B8B8)",
    icon: "var(--wp-status-danger-icon, #B32D2D)",
    text: "var(--wp-status-danger-text, #7C2020)",
  },
};

export default function MovementCoachBubble({ title, children, tone = "info", compact = false }) {
  const palette = TONES[tone] || TONES.info;

  return (
    <Box
      sx={{
        position: "relative",
        px: compact ? 1.5 : 1.8,
        py: compact ? 1.2 : 1.5,
        bgcolor: palette.bg,
        border: `1px solid ${palette.border}`,
        borderRadius: 2.5,
        color: palette.text,
        "&::after": {
          content: '""',
          position: "absolute",
          left: 22,
          bottom: -7,
          width: 13,
          height: 13,
          bgcolor: palette.bg,
          borderRight: `1px solid ${palette.border}`,
          borderBottom: `1px solid ${palette.border}`,
          transform: "rotate(45deg)",
        },
      }}
    >
      <Stack direction="row" spacing={1.1} alignItems="flex-start">
        <InfoOutlinedIcon sx={{ mt: 0.15, fontSize: compact ? 19 : 21, color: palette.icon }} />
        <Box>
          {title ? <Typography sx={{ fontWeight: 900, lineHeight: 1.25 }}>{title}</Typography> : null}
          <Typography variant="body2" sx={{ mt: title ? 0.35 : 0, lineHeight: 1.5, color: "inherit" }}>
            {children}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}
